<template>
  <div>

    <card title="Affiliates" :subtitle="subtitle">
      <div>
        <Affiliates-Table :hidePosition="!singleView" :hideCompany="singleView"/>
      </div>
      <!-- <div slot="footer" class="stats">
       <i class="far fa-clock"/> This Month
      </div> -->
    </card>

  </div>
</template>

<script>
export default {
  name: 'Affiliates-Card',
  props: {
    singleView: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    subtitle () {
      var label = this.$store.getters.periodSelected ? this.$store.getters.periodSelected.label : ''
      return 'Activity ' + (label ? label.toLowerCase() : '')
    }
  }
}
</script>

<style>

</style>